import { useLocation, Navigate, Outlet } from 'react-router-dom';

import useAuth from '@frolight/hooks/useAuth';

const RequireGuest = () => {
  const { auth } = useAuth();
  const location = useLocation();

  return (
    !auth?.accessToken?.token
      ? <Outlet />
      : <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireGuest;
